<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@inviteManufacturer">Invite Manufacturer</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="inviteManufacturerForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@manufacturerContactPersonNameLabel">Manufacturer contact person name</mat-label>
        <input data-testid="manufacturerContactPersonName" matInput id="name" i18n-placeholder="@@manufacturerContactPersonNamePlaceholder" placeholder="Manufacturer contact person name" name="name" formControlName="name" required />
        <mat-error *ngIf="inviteManufacturerForm.get('name')?.touched && inviteManufacturerForm.get('name')?.invalid">
          <span *ngIf="inviteManufacturerForm.get('name')?.errors?.['required'] || inviteManufacturerForm.get('name')?.hasError('whitespace')" i18n="@@inValidRequiredField">
            This field is required
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@manufacturerEmailLabel">Manufacturer email</mat-label>
        <input data-testid="manufacturerEmail" matInput id="email" placeholder="Manufacturer email" i18n-placeholder="@@manufacturerEmailPlaceholder" name="email" formControlName="email" required />
        <mat-error *ngIf="inviteManufacturerForm.get('email')?.touched && inviteManufacturerForm.get('email')?.invalid">
          <span *ngIf="inviteManufacturerForm.get('email')?.errors?.['required']" i18n="@@inValidRequiredField">
            This field is required
          </span>
          <span *ngIf="inviteManufacturerForm.get('email')?.errors?.['email'] || inviteManufacturerForm.get('email')?.errors?.['emailNotValid']" i18n="@@inValidEmail">
            Please enter a valid email
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@phoneNumberLabel">Phone number</mat-label>
        <input (keypress)="numberOnly($event)" data-testid="profile_phone" matInput id="phone_number" i18n-placeholder="@@phoneNumberPlaceholder" placeholder="Phone number" name="phone_number" formControlName="phone_number" required />
        <mat-error>
          @if (!inviteManufacturerForm.get('phone_number').valid && inviteManufacturerForm.get('phone_number').touched) {
            @if (inviteManufacturerForm.get('phone_number').errors && inviteManufacturerForm.get('phone_number').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (inviteManufacturerForm.get('phone_number').errors && inviteManufacturerForm.get('phone_number').errors['minlength'] && !inviteManufacturerForm.get('phone_number').errors['required']) {
            <span i18n="@@invalid_phone_min_length">Please enter 7 digits minimum</span>
          }
          @if (inviteManufacturerForm.get('phone_number').errors && inviteManufacturerForm.get('phone_number').errors['maxlength'] && !inviteManufacturerForm.get('phone_number').errors['required']) {
            <span i18n="@@invalid_phone_max_length">Please enter 14 digits maximum</span>
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div>
      <button i18n="@@invite" data-testid="invite_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Invite</button>
    </div>
  </form>
</mat-dialog-content>